import { useMemo } from 'react';

import { AIShellWrapper, AssistantProvider } from '@captivateiq/assistant';
import type { TranslationOverrides } from '@captivateiq/assistant';

import { useIsFeatureEnabled } from 'contexts/FeatureFlags';
import { CSRFService } from 'services';
import { UsersService } from 'services/users';
import { TQAPIServiceAdapter, TQUserServiceAdapter } from 'services/assistant';

const appActionTranslationOverrides: TranslationOverrides = {
  'en-US': {
    assistant: {
      app_actions: {
        apply_account_dealer_config: 'Applied account dealer config',
      },
    },
  },
};

export const SPMAssistantProvider: React.VFC<{ children?: React.ReactNode }> = ({ children }) => {
  const isEnabled = useIsFeatureEnabled('feature_flag_ai_assistant_sdk');
  const { query: csrfQuery } = CSRFService.useGetCSRFToken();
  const { query: userQuery } = UsersService.useGetCurrentUserQuery();

  const apiService = useMemo(
    () => (csrfQuery.data ? new TQAPIServiceAdapter(csrfQuery.data.csrf) : null),
    [csrfQuery.data],
  );
  const userService = useMemo(
    () => (userQuery.data ? new TQUserServiceAdapter(userQuery.data) : null),
    [userQuery.data],
  );

  if (!isEnabled || !apiService || !userService) {
    return <>{children}</>;
  }

  return (
    <AssistantProvider translationsOverride={appActionTranslationOverrides}>
      <AIShellWrapper apiService={apiService} userService={userService}>
        {children}
      </AIShellWrapper>
    </AssistantProvider>
  );
};
